import React from 'react';
import fr from 'facet-rest';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { navigateToPage } from 'Views/Page/Content/Templates';
import { FDCallToActionButton, FDStack } from '@facet-wealth/design';

const RoadmapDeliverableReviewRoadmap = ({ resource }) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const handlePrimaryButtonClick = resource.withRelationship(fr.relationships.primaryAction.name,
    (rel) => () => {
      logStandardizedEvent(categories.clientWhatIf, eventTypes.clickButton, 'Household Next Action - Primary dashboard button clicked', {
        eventProperties: {
          prompt: rel.meta('prompt'),
          link: rel.link('related').url(),
        },
      });
      navigateToPage(rel.link('related').url(), false);
    },
    () => null);

  return resource.withRelationship(fr.relationships.primaryAction.name,
    (rel) => (
      <FDStack justifyContent={'center'}>
        <FDCallToActionButton label={rel.meta('prompt')} onClick={handlePrimaryButtonClick} />
      </FDStack>
    ),
    () => null);
};

export { RoadmapDeliverableReviewRoadmap };
